// src/store/formSlice.js
import { createSlice } from '@reduxjs/toolkit';

type University = {
  degree: string;
  university: string;
};

type Subject = {
  id: string;
  name: string;
};

interface TeacherFormState {
  staff_code: string;
  salut: string;
  first_name: string;
  gender: string;
  last_name: string;
  dob: string;
  image: string;
  contact_no: string;
  address: string;
  assert_id: string;
  email: string;
  upload: string;
  medium: string;
  is_visit: boolean;
  level: string;
  is_active: boolean;
  degree: string;
  university: string;
  primary_subject: Subject[];
  secondary_subject: Subject[];
  universityList: University[];
}

const initialState: TeacherFormState = {
  staff_code: '',
  salut: '',
  first_name: '',
  gender: '',
  last_name: '',
  dob: '',
  image: '',
  contact_no: '',
  address: '',
  assert_id: '',
  email: '',
  upload: '',
  medium: '',
  is_visit: false,
  level: '',
  is_active: true,
  degree: '',
  university: '',
  primary_subject: [],
  secondary_subject: [],
  universityList: [],
};

const formSlice = createSlice({
  name: 'form',
  initialState,
  reducers: {
    setTeacherFormValues(state, action) {
      return { ...state, ...action.payload };
    },
    resetForm() {
      return initialState;
    },

    addUniversity(state, action) {
      state.universityList.push(action.payload);
    },
    removeUniversity(state, action) {
      state.universityList = state.universityList.filter(
        (uni) =>
          uni.degree !== action.payload.degree || uni.university !== action.payload.university,
      );
    },
    resetUniversityList(state) {
      state.universityList = [];
    },
  },
});

export const {
  setTeacherFormValues,
  resetForm,
  addUniversity,
  removeUniversity,
  resetUniversityList,
} = formSlice.actions;
export default formSlice.reducer;
